module.exports = __webpack_public_path__ + "static/media/starts_with_b.02c2ba17.mp3";